export default "__VITE_ASSET__Bh6C0djw__"